import Decimal from 'decimal.js';

interface FormatDecimalParams {
	value?: Decimal.Value;
	exchangeRate?: Decimal.Value;
}

export const formatDecimal = ({
	value,
	exchangeRate,
}: FormatDecimalParams): string => {
	if (value === undefined || exchangeRate === undefined) return '';

	const amount = new Decimal(value);
	const eurValue = amount.times(exchangeRate);

	if (eurValue.gte(1000)) {
		return amount.toFixed(2, Decimal.ROUND_DOWN);
	} else if (eurValue.gte(1)) {
		return amount.toFixed(4, Decimal.ROUND_DOWN);
	} else if (eurValue.gte(0.01)) {
		return amount.toFixed(4, Decimal.ROUND_DOWN);
	} else if (eurValue.gte(0.001)) {
		return amount.toFixed(6, Decimal.ROUND_DOWN);
	} else {
		return amount.toFixed(8, Decimal.ROUND_DOWN);
	}
};

// if (eurValue.gte(1000)) {
// 	return amount.toFixed(2);
// } else if (eurValue.gte(1)) {
// 	return amount.toFixed(4);
// } else if (eurValue.gte(0.01)) {
// 	return amount.toFixed(4);
// } else if (eurValue.gte(0.001)) {
// 	return amount.toFixed(6);
// } else {
// 	const scientific = amount.toExponential(2);
// 	return scientific.length < 12 ? scientific : amount.toFixed(8);
// }

/* ----------------------------- spacing testing ---------------------------- */
// export const formatDecimal = ({
// 	value,
// 	exchangeRate,
// }: FormatDecimalParams): string => {
// 	return new Decimal(value).toFixed(14);
// };
